import { render, staticRenderFns } from "./orderDetailZS.vue?vue&type=template&id=5a21111c&scoped=true"
import script from "./orderDetailZS.vue?vue&type=script&lang=ts"
export * from "./orderDetailZS.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailZS.vue?vue&type=style&index=0&id=5a21111c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21111c",
  null
  
)

export default component.exports